import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  imports: [
    RouterOutlet
  ],
  styleUrl: './legal.component.scss'
})
export class LegalComponent {

}
